import type { ComponentProps } from 'react';

export const BackArrowIcon = (props:ComponentProps<'svg'>) => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M27.5926 18C25.6315 21.4645 23.0325 24.5266 19.9327 27.0247L15 31M15 31L19.9328 34.9753C23.0325 37.4734 25.6315 40.5355 27.5926 44M15 31L49 31"
      stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="bevel" />
  </svg>
)